import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-block" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-center justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border mt-3",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_6 = { class: "mt-3 text-bg-light p-3 fs-md-13 fs-lg-14" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-copy" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isOpen) = $event)),
    centered: "",
    title: !_ctx.streamedData && !_ctx.isDrafting ? 'Thinking...' : (_ctx.isDrafting && !_ctx.streamedData ? 'Writing draft...' : 'Your 1st Look Draft'),
    "hide-footer": "",
    "dialog-class": _ctx.streamedData ? 'modal-md' : 'modal-sm',
    onHide: _ctx.close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isDrafting && !_ctx.streamedData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.streamedData && _ctx.isDrafting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.streamedData) = $event)),
                readonly: "",
                style: {"display":"none"}
              }, null, 512), [
                [_vModelText, _ctx.streamedData]
              ]),
              _createElementVNode("div", _hoisted_6, [
                (!_ctx.isStreaming)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      innerHTML: _ctx.streamedData
                    }, null, 8, _hoisted_7))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      innerHTML: _ctx.streamedData.replace(/\n/g, '<br>')
                    }, null, 8, _hoisted_8))
              ]),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args))),
                class: "btn btn-sm btn-secondary position-absolute bottom-0 end-0 mb-1 me-1"
              }, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "dialog-class", "onHide"]))
}